import {
  PromoCodeMetadata,
  TournamentPass,
  UserPasses,
} from '@fantaz/shared/data-access/models';
import { createAction, props } from '@ngrx/store';

export const init = createAction('[Passes Page] Init');

export const loadTournamentPasses = createAction(
  '[Passes Page] Load Tournaments Passes',
  props<{
    eventPrototypeUuid: string;
    eventScheduleUuid: string;
    userId?: string;
    options?: {
      refresh?: boolean;
    };
  }>(),
);

export const loadPassesSuccess = createAction(
  '[Passes/API] Load Passes Success',
  props<{ passes: TournamentPass[] }>(),
);

export const loadPassesFailure = createAction(
  '[Passes/API] Load Passes Failure',
  props<{ error: any }>(),
);

// buy tournament pass
export const buyTournamentPass = createAction(
  '[Passes Page] Buy Tournament Pass',
  props<{
    eventPrototypeUuid: string;
    eventScheduleUuid: string;
    tournamentName: string;
    gameName?: string;
    fantazPassUuid: string;
    promoCodes?: PromoCodeMetadata[];
    price: number;
    playOnBuy?: any;
    passIndex: number;
  }>(),
);

export const clearPasses = createAction('[Passes Page] Clear Passes');

export const buyPassSuccess = createAction(
  '[Passes/API] Buy Pass Success',
  props<{
    pass: UserPasses;
    fantazPassUuid: string;
    playOnBuy?: any;
    meta: {
      tournamentName: string;
      gameName?: string;
    };
  }>(),
);

export const buyPassFailure = createAction(
  '[Passes/API] Buy Pass Failure',
  props<{ error: any; fantazPassUuid: string }>(),
);

export const refreshPasses = createAction(
  '[Passes Page] Refresh Tournaments Passes',
);

export const updatePassLocally = createAction(
  '[Passes Page] Update Pass Locally',
  props<{
    uuid: string;
    updates?: Partial<TournamentPass>;
  }>(),
);
